import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { PreviousSearchItemDesktop } from './PreviousSearchItemDesktop';
import { getFilteredPreviousSearches } from '../../redux/previousSearch/selectors';
import { setAllSearch } from '../../redux/currentSearch/actions';

export function PreviousSearchesDesktop(props) {
    // TODO: trackingId from source?
    const { maxLength, options, show } = props;
    const FilteredPreviousSearches = useSelector(getFilteredPreviousSearches, shallowEqual);
    const dispatch = useDispatch();

    const searchesToDisplay = (FilteredPreviousSearches || []).slice(0, maxLength);
    const onClickItem = (search) => {
        dispatch(setAllSearch(search));
        props.onClickItem();
    };

    return (
        <React.Fragment>
            { show && searchesToDisplay.map((item, i) => (
                <PreviousSearchItemDesktop
                    key={item.createdAt}
                    index={i}
                    onClickItem={onClickItem}
                    value={item}
                    trackingId={options.trackingId}
                />
            ))}
        </React.Fragment>
    );
}

PreviousSearchesDesktop.propTypes = {
    maxLength: PropTypes.number.isRequired,
    options: PropTypes.object,
    onClickItem: PropTypes.func,
    show: PropTypes.bool,
};

PreviousSearchesDesktop.defaultProps = {
    onClickItem: ()=>{},
    options: {},
    show: true,
};
